import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fireErrorAnalytics as fireErrorAnalyticAndLogToSentry } from '@atlassian/error-handling';
import { getErrorType } from './get-error-type';
export var maskEmailIdsInMessage = function maskEmailIdsInMessage(message) {
  return message.replaceAll(/\w+@[\w.]+/gi, '***@***');
};
export var fireErrorAnalytics = function fireErrorAnalytics(_ref) {
  var error = _ref.error,
    id = _ref.id,
    viewType = _ref.viewType,
    _ref$attributes = _ref.attributes,
    attributes = _ref$attributes === void 0 ? {} : _ref$attributes,
    event = _ref.event;
  var errorType = getErrorType(error);
  var packageName = "".concat(viewType, "jiraUiModifications");
  fireErrorAnalyticAndLogToSentry({
    event: event,
    meta: {
      id: id,
      packageName: packageName,
      teamName: 'unbox'
    },
    error: error,
    attributes: _objectSpread({
      errorType: errorType,
      errorMessage: typeof error.message === 'string' ? maskEmailIdsInMessage(error.message) : error.message
    }, attributes)
  });
};